'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeFitnessLeaderboard = exports.fetchFitnessLeaderboard = exports.c = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var c = exports.c = {
  ENDPOINT: 'api/v2/search/fitness_activities_totals'
};

/**
 * @function fetches supporter pages ranked by fitness activities
 */
var fetchFitnessLeaderboard = exports.fetchFitnessLeaderboard = function fetchFitnessLeaderboard() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if ((0, _client.isJustGiving)()) {
    return Promise.reject('This method is not supported for JustGiving');
  }

  var transforms = {
    type: function type(val) {
      return val === 'team' ? 'teams' : val === 'group' ? 'groups' : 'individuals';
    },

    sortBy: function sortBy(val) {
      switch (val) {
        case 'calories':
          return 'calories';
        case 'duration':
          return 'duration_in_seconds';
        case 'elevation':
          return 'elevation_in_meters';
        default:
          return 'distance_in_meters';
      }
    }
  };

  var mappings = {
    activity: 'type',
    groupID: 'group_id',
    type: 'group_by',
    sortBy: 'sort_by'
  };

  return (0, _client.get)(c.ENDPOINT, params, { mappings: mappings, transforms: transforms }).then(function (response) {
    return response.results;
  });
};

/**
 * @function a default deserializer for leaderboard pages
 */
var deserializeFitnessLeaderboard = exports.deserializeFitnessLeaderboard = function deserializeFitnessLeaderboard(result, index) {
  if (result.page) {
    return deserializePage(result.page, result, index);
  } else if (result.team) {
    return deserializePage(result.team, result, index);
  } else if (result.group) {
    return deserializeGroup(result, index);
  }
};

var deserializePage = function deserializePage(item, result, index) {
  return {
    position: index + 1,
    id: item.id,
    name: item.name,
    charity: item.charity_name,
    charityLogo: item.charity_logo_url,
    url: item.url,
    donationUrl: item.donation_url,
    image: item.image.medium_image_url,
    raised: item.amount.cents,
    groups: item.group_values,
    distance: result.distance_in_meters,
    elevation: result.elevation_in_meters,
    calories: result.calories,
    duration: result.duration_in_seconds
  };
};

var deserializeGroup = function deserializeGroup(item, index) {
  return {
    position: index + 1,
    count: item.count,
    id: item.group.id,
    name: item.group.value,
    raised: item.amount_cents / 100,
    distance: item.distance_in_meters,
    elevation: item.elevation_in_meters,
    calories: item.calories,
    duration: item.duration_in_seconds
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/fitness-leaderboard/index.js
// module id = 491
// module chunks = 0